import { ItemPage } from 'pageModules/ItemPage';

export default ItemPage;
